import { DocumentNode, gql } from '@apollo/client';

export const CreatePDF: DocumentNode = gql`
    mutation CreatePDF($input: CreatePDFInput!) {
        createPDF(input: $input) {
            url
        }
    }
`;
